import { render } from "./ModalWrapper.vue?vue&type=template&id=091dca84&scoped=true"
import script from "./ModalWrapper.vue?vue&type=script&lang=js"
export * from "./ModalWrapper.vue?vue&type=script&lang=js"

import "./ModalWrapper.vue?vue&type=style&index=0&id=091dca84&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091dca84"]])

export default __exports__